import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clicksend = defineConnector({
  identifier: "clicksend",
  name: "ClickSend",
  tagLine: "Messaging and SMS delivery",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://rest\\.clicksend\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Find your ClickSend API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [ClickSend authentication docs](https://developers.clicksend.com/docs/rest/v3/?javascript#authentication) and copy your API username and API key from the ClickSend dashboard. If needed, generate a new API key before continuing.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your ClickSend account settings.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
          helperText: "Your ClickSend account username",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "password" },
          helperText: "Your ClickSend API Key",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://rest.clicksend.com/v3/account",
  },
});
